var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFaq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51,
    height: 43,
    viewBox: "0 0 51 43",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1279_2369)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.981445 6.45005V37.1563C0.981445 39.607 2.90831 41.5947 5.28452 41.5947H5.363C7.73921 41.5947 9.66607 39.607 9.66607 37.1563V0.981445H49.8693V37.1563C49.8693 39.607 47.9424 41.5947 45.5662 41.5947H5.32376",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.38184 3.45312V37.3852",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.7886 11.0664H13.6309V23.2241H25.7886V11.0664Z",
    fill: "#3C8EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.3954 5.22363H13.6309V9.06363H46.3954V5.22363Z",
    fill: "#3C8EB0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 11.9873H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 15.6426H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 19.2998H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0596 22.957H46.3962",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 26.6152H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 30.2725H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 33.9277H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6309 37.5859H46.3954",
    stroke: "#3C8EB0",
    strokeWidth: 1.96218,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1279_2369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 50.85,
    height: 42.5755,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFaq);
export default __webpack_public_path__ + "static/media/faq.39a4ab89af116f672bcbef36684f3fdb.svg";
export { ForwardRef as ReactComponent };